import Vue from 'vue';
import Vuex from 'vuex';
import { auth } from './auth.store';
import { newsletter } from './newsletter.store';
import { message } from './message.store';
import { birthday } from './birthday.store';
import { smsCollection } from './sms-collection.store';
import { user } from './user.store';
import { app } from './app.store';
import { affiliate } from './affiliate-referral.store';
import { agent } from './agent.store';
import { extensibleSms } from './extensible-sms.store';
import { dashboard } from './dashboard.store';
import { credo } from './credo.store';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    newsletter,
    message,
    birthday,
    smsCollection,
    user,
    app,
    affiliate,
    agent,
    extensibleSms,
    dashboard,
    credo,
  },
});
